import type { FaireProductEntity } from "../../entity_types/product";

export const p_yupe7a9nyj: FaireProductEntity = {
  token: "p_yupe7a9nyj",
  type: "product",
  name: "Roasted Garlic EVOO Blend – Robust Flavor (250mL Cruet)",
  brandToken: "b_wc2q3m3rxc",
  brandName: "Hongar Farms",
  imageUrl: "https://cdn.faire.com/fastly/748d0e3ea67789d2fa6802e36dea090caa8222ae37b48a6167dc1b7e6c143761.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5b8af50feee24902f2e263152775af07ef47fc4b758a61258d070a0fee9e3d58.jpeg",
    "https://cdn.faire.com/fastly/d24307a789413e9f6bd1a042fb11db13652017884936222fd43ef1a0320d97b1.jpeg",
    "https://cdn.faire.com/fastly/d0fdc74c50375b4af6ae3db2bf0753aa82d17f67a66d5f62e8a524ba2463f5c5.png",
    "https://cdn.faire.com/fastly/3b3a26df32da56ab21bcd47bcf53e76f92301b96c62284bc92418e5948065ad9.png"
  ],
  priceDollars: 7.26,
  description: "Hongar Farms Roasted Garlic Infused EVOO Blend bursts with bright, natural garlic flavor, crafted from all-natural ingredients. This versatile oil blend enhances roasting veggies, chicken, fish, and more with rich, savory notes. Packaged in a convenient 250mL glass Cruet bottle with handle and lip for easy pouring, it’s perfect for everyday cooking or gifting.\n\nSpecs:\n\n-Fluid Size: 250 mL (8.45 fl oz)\n-Height: 7.5 in | Width: 2.25 in | Depth: 2.25 in\n-Weight: 0.8 lbs\n-Color: Golden with Roasted Garlic Aroma\n-Taste: Robust, Savory, Aromatic\n\nUsage:\nCelebrations, Memorial Day, Easter, Mother’s Day, Spring & Summer Parties, Dinner Parties, Grilling, Charcuterie Boards, Healthy Cooking Oils, Italian Cooking, Gift Giving\n\nNotes:\nAll Natural, No Preservatives, Small Batch, Made in USA (Georgia), Fresh Ingredients, Infused Cooking Oil, Artisan Crafted, Gourmet Quality, Sustainably Sourced",
  tags: [],
  msrpDollars: 14.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:11.093Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
